
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Formulas from './components/Formulas';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Awards from './components/Awards';
import Contact from './components/Contact';
import StickyHeader from '../../components/feature/StickyHeader';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <StickyHeader />
      <div id="accueil">
        <Hero />
      </div>
      <div id="apropos">
        <About />
      </div>
      <div id="services">
        <Services />
      </div>
      <div id="formules">
        <Formulas />
      </div>
      <div id="galerie">
        <Gallery />
      </div>
      <div id="avis">
        <Testimonials />
      </div>
      <div id="recompenses">
        <Awards />
      </div>
      <div id="contact">
        <Contact />
      </div>
    </div>
  );
};

export default HomePage;
